export enum ongletsAjoutType {
	interne = 'interne',
	externe = 'externe'
}
